import React, { useMemo, useState } from 'react';

export interface EventInterface {
    image?: string;
    name: string;
    description: string;
    timeEnd: string;
    timeText: string;
    location: string;
    link: string;
};

interface FutureEventsInterface {
    futureEvents: EventInterface[];
};

function FutureEvent ({ image, name, timeText, location, link }: EventInterface) {
    const calendarImg = require("../images/calendar.png");
    const locationImg = require("../images/location.png");

    return (
        <div className="futureEventsEventWrapper">
            <div className="futureEventsEventLine">
                <div className="futureEventsEventLine1"></div>
                <div className="futureEventsEventLine2"></div>
                <div className="futureEventsEventLine3"></div>
            </div>
            <div className="futureEventsEventContentWrapper">
                <div className="futureEventsEventTopWrapper">
                    <img className="futureEventsEventImage" src={require(`../images/events/${image}`)} alt="upcoming event"/>
                    <div className="futureEventsEventInfoWrapper">
                        <div className="futureEventsEventName">{name}</div>
                        <div className="futureEventsEventDetailWrapper">
                            <img className="futureEventsEventDetailIcon" src={calendarImg} alt="event time icon"/>
                            <div className="futureEventsEventDetail">{timeText}</div>
                        </div>
                        <div className="futureEventsEventDetailWrapper">
                            <img className="futureEventsEventDetailIcon" src={locationImg} alt="event location icon"/>
                            <div className="futureEventsEventDetail">{location}</div>
                        </div>
                    </div>
                </div>
                <button className="futureEventsEventButton">EVENT DETAILS</button>
            </div>
        </div>
    );
}

function FutureEvents({ futureEvents }: FutureEventsInterface) {
    const [showPartialList, setShowPartialList] = useState(true);

    const futureEventsFinal = useMemo(() => {
        if (showPartialList) {
            return futureEvents.slice(0, 2);
        }
        return futureEvents;
    }, [showPartialList, futureEvents]);

    const handleShowMoreLessClick = () => {
        setShowPartialList(!showPartialList);
    }

    return (
        <div className="futureEventsWrapper">
            <div className="futureEventsTitleWrapper">
                <div className="futureEventsTitleLine"></div>
                <div className="futureEventsTitle">UPCOMING EVENTS</div>
            </div>
            <div className="futureEventsListWrapper">
                {futureEventsFinal.map((futureEvent, idx) =>
                    <FutureEvent key={idx} image={futureEvent.image} name={futureEvent.name} description={futureEvent.description} timeEnd={futureEvent.timeEnd} timeText={futureEvent.timeText} location={futureEvent.location} link={futureEvent.link} />
                )}
            </div>
            <button className="futureEventsShowMoreLessButton" onClick={handleShowMoreLessClick}>{showPartialList ? "SHOW MORE" : "SHOW LESS"}</button>
        </div>
    )
}

export default FutureEvents;